import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-dos-select-modal',
    templateUrl: './dos-select-modal.component.html',
    styleUrl: './dos-select-modal.component.scss',
    imports: [FormsModule, NgIf]
})
export class DosSelectModalComponent {
  dosMin: number = 1;
  dosMax: number = 90;
  errorMessage: string | null = null;

  constructor(public activeModal: NgbActiveModal) {}

  save() {
    // Ensure valid values
    if (this.dosMin < 1) {
      this.errorMessage = 'Min DOS must be at least 1';
      return;
    }
    if (this.dosMax < this.dosMin) {
      this.errorMessage = 'Max DOS must be greater than or equal to Min DOS';
      return;
    }

    this.activeModal.close({ dosMin: this.dosMin, dosMax: this.dosMax });
  }

  close() {
    this.activeModal.dismiss();
  }
}